import { icons, logos } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  .reddit_to_yolorekt {
    background: hsla(0, 0%, 90%, 0.1);
    backdrop-filter: blur(25px);
    display: flex;
    border-radius: 10px;
    padding: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    flex-direction: column;
    width: 300px;
    justify-content: center;
    align-items: center;
  }
  .reddit_to_yolorekt h1 {
    font-size: 1.2rem;
    font-weight: 600;
    padding: 0 0 10px 0;
  }
  .reddit_to_yolorekt h2 {
    font-size: 0.8rem;
  }
  .reddit_to_yolorekt .logos_connect {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    margin: 15px 0 0 0;
  }
  .reddit_to_yolorekt .reddit_icon {
    background: url(${icons.reddit_icon}) center center / 45px auto no-repeat;
    width: 45px;
    height: 45px;
  }
  .reddit_to_yolorekt .connect_icon {
    width: 22px;
    height: 22px;
    margin: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .reddit_to_yolorekt .connect_icon .linked {
    background: url(${icons.linked_icon}) center center / 22px auto no-repeat;
    width: 22px;
    height: 22px;
  }
  .reddit_to_yolorekt .connect_icon .error {
    mask: url(${icons.ErrorIcon}) center center / 22px auto no-repeat;
    background: #fff;
    width: 22px;
    height: 22px;
  }
  .reddit_to_yolorekt .yolorekt_icon {
    background: url(${logos.yolorekt_moon_white}) center center / 45px auto
      no-repeat;
    width: 45px;
    height: 45px;
  }
`

const developerCSS = css``

export const RedditLinkCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
